// components/SEO.jsx
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  schema,
  openGraph 
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    <link rel="canonical" href={canonical} />
    <meta property="og:title" content={openGraph?.title || title} />
    <meta property="og:description" content={openGraph?.description || description} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={canonical} />
    <meta property="og:image" content={openGraph?.image} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="robots" content="index, follow" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="google-site-verification" content="-OAVng-veWJGqdJiSOi2Y18xf0pMwFTXGL2tXHFaSMQ" />
    {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
  </Helmet>
);

export default SEO;

// Enhanced content with natural keyword integration
const optimizedContent = {
  heroTitle: "Compassionate Home Care Services in Dallas-Fort Worth",
  heroSubtitle: "Premier elderly care and senior care agency providing personalized in-home care services",
  metaDescription: "MASA HILLS Health Services offers professional home care services, elderly care, and senior care in Dallas-Fort Worth. Licensed caregivers provide compassionate in-home care services for seniors and disabled adults.",
  keywords: "home care services, elderly care, senior care agency, in-home care services, home health care, Dallas Fort Worth, Texas"
};